module.exports = __webpack_public_path__ + "static/MPfull_1-3c54f14a2cc71adff63bd0fad592fc22.png";